/*
 * Copyright © 2020-2025 Ocean Galaxy Inc. All Rights Reserved.
 * @Description: 排序切换组件
 * @LastEditors: jiakaiwen jiakaiwen@huihaiyinhe.com
 * @LastEditTime: 2025-11-25 09:56:35
 */

import React from 'react'
import { Tooltip, message } from 'antd'
import caretUp from '../../images/caret_up.png'
import caretDown from '../../images/caret_down.png'
import { useAppSelector } from '../../app/hooks'

interface SortOrderToggleProps {
  isAsc: boolean // true为升序/时间顺序，false为降序/时间倒序
  onToggle: (isAsc: boolean) => void // 切换回调
  className?: string
  style?: React.CSSProperties
}

const SortOrderToggle: React.FC<SortOrderToggleProps> = ({
  isAsc,
  onToggle,
  className = '',
  style = {}
}) => {
  // 根据当前排序状态，决定显示文本和Tooltip内容
  const text = isAsc ? '时间顺序' : '时间倒序'
  const tooltip = isAsc ? '点击倒序' : '点击顺序'

  // 通过状态活跃度判断使用新版还是旧版状态（暂时兼容，未来将完全使用新版状态）
  const isGroupPhotoViewLimit = useAppSelector((state) => {
    const contentState = state.photosByContent
    const isContentActive =
      contentState &&
      (contentState.photos?.length > 0 ||
        contentState.loading === true ||
        contentState.expandInfo !== null)

    if (isContentActive) {
      // 新版状态正在使用
      return contentState.isGroupPhotoViewLimit || false
    } else {
      // 旧版状态正在使用，使用 state.photo
      return state.photo?.isGroupPhotoViewLimit || false
    }
  })
  const handleClick = () => {
    if (isGroupPhotoViewLimit) {
      message.warning('团队人数已超上限，暂无法查看部分照片')
      return
    }
    onToggle(!isAsc)
  }

  return (
    <Tooltip
      title={tooltip}
      placement="top"
      styles={{ root: { fontSize: '14px' } }}
    >
      <span
        className={`sort-order-toggle ${className}`}
        style={{
          cursor: 'pointer',
          marginLeft: 16,
          display: 'inline-flex',
          alignItems: 'center',
          fontSize: 14,
          color: '#333',
          ...style
        }}
        onClick={handleClick}
      >
        {text}
        <span
          style={{
            marginLeft: 4,
            display: 'inline-flex',
            alignItems: 'center',
            height: 20,
            width: 12
          }}
        >
          {isAsc === false ? (
            <img
              src={caretUp}
              style={{
                width: 14,
                height: 14
              }}
            />
          ) : (
            <img
              src={caretDown}
              style={{
                width: 14,
                height: 14
              }}
            />
          )}
        </span>
      </span>
    </Tooltip>
  )
}

export default SortOrderToggle
